export default __webpack_public_path__ + "figma.60169a19.png";